import type { GenerateOtcResponse } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function generateOtc({
  patientId,
}: {
  patientId: string;
}): Promise<GenerateOtcResponse> {
  return sharedRequestsTyped.generate_otc({
    context: { showLoader: false },
    searchParams: { patient_id: patientId },
  });
}
